import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    event.preventDefault()

    const key = event.currentTarget.dataset.citationKey
    if (!key) return

    const item = document.getElementById(`report-evidence-${key}`)
    if (!item) return

    this.element.querySelectorAll(".report-evidence-item--active").forEach((node) => {
      node.classList.remove("report-evidence-item--active")
    })

    item.classList.add("report-evidence-item--active")
    item.scrollIntoView({ behavior: "smooth", block: "nearest" })
  }
}
